import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const ScrollToTop = () => {
  const { pathname, search } = useLocation();

  useEffect(() => {
    // Public pages recover only after their lazy content commits inside PublicSiteSurface.
    // Preserve legacy behavior for admin/auth and hosted customer documents.
    if (!/^\/(admin(?:\/|$)|\.lovable\/|unsubscribe(?:\/|$)|q\/|quote\/|roof-quote\/)/.test(pathname)) return;
    // Scroll on pathname OR query-string change so in-page navigations like
    // /book-service → /book-service?category=solar-cleaning still reset scroll.
    window.scrollTo({ top: 0, left: 0 });
  }, [pathname, search]);

  return null;
};

export default ScrollToTop;
